import { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { api, sessao, FLUXO, ST_LABEL, ST_COR, fmtData, ESFERICOS, CILINDRICOS, ADICOES } from '../api';
import { Icone } from '../Icones.jsx';

const TIPO = { acetato: 'Acetato', metal: 'Metal', metal_nylon: 'Metal/Nylon', parafusado: 'Parafusado' };
const v = x => (x === null || x === undefined || x === '' ? '—' : x);

export default function OrdemDetalhe() {
  const { id } = useParams();
  const nav = useNavigate();
  const u = sessao.usuario;
  const [os, setOs] = useState(null);
  const [erro, setErro] = useState('');
  const [novaDiv, setNovaDiv] = useState(null);
  const [perdaTxt, setPerdaTxt] = useState(null);
  const [editando, setEditando] = useState(null); // cópia editável da OS
  const [fornecedores, setFornecedores] = useState([]);
  useEffect(() => {
    if (podeDivergencia) api('/fornecedores').then(setFornecedores).catch(() => {});
  }, []);
  const salvarExp = async body => {
    try { await api(`/ordens/${id}/expedicao`, { method: 'PATCH', body }); carregar(); }
    catch (e) { setErro(e.message); }
  };

  const iniciarEdicao = () => {
    const e = {};
    ['numero_os','cliente','vendedor','armacao','lente','tratamento1','tratamento2',
     'tipo_armacao','olhos','observacoes','largura','altura_arm','ponte','diagonal',
     'od_esferico','od_cilindrico','od_eixo','od_altura','od_dnp','od_adicao',
     'oe_esferico','oe_cilindrico','oe_eixo','oe_altura','oe_dnp','oe_adicao']
      .forEach(k => { e[k] = os[k] ?? ''; });
    setEditando(e);
  };
  const salvarEdicao = async () => {
    try {
      await api(`/ordens/${id}`, { method: 'PATCH', body: editando });
      setEditando(null); carregar();
    } catch (e) { setErro(e.message); }
  };
  const ed = (k, v) => setEditando(p => ({ ...p, [k]: v }));

  const cancelarOS = async () => {
    const motivo = prompt('Motivo do cancelamento (opcional):');
    if (motivo === null) return;
    try { await api(`/ordens/${id}/cancelar`, { method: 'POST', body: { motivo } }); carregar(); }
    catch (e) { setErro(e.message); }
  };
  const reativarOS = async () => {
    if (!confirm(`Reativar a OS ${os.numero_os}? Ela volta ao status "${ST_LABEL[os.status]}".`)) return;
    try { await api(`/ordens/${id}/reativar`, { method: 'POST' }); carregar(); }
    catch (e) { setErro(e.message); }
  };

  const excluirOS = async () => {
    if (!confirm(`Excluir definitivamente a OS ${os.numero_os} (${os.cliente})? O histórico, as divergências e as fotos serão apagados. Esta ação não pode ser desfeita.`)) return;
    try { await api(`/ordens/${id}`, { method: 'DELETE' }); nav('/ordens'); }
    catch (e) { setErro(e.message); }
  };

  const registrarPerda = async () => {
    if (!perdaTxt?.trim()) return;
    try {
      await api(`/ordens/${id}/perda`, { method: 'POST', body: { descricao: perdaTxt } });
      setPerdaTxt(null); carregar();
    } catch (e) { setErro(e.message); }
  };
  const podeDivergencia = u.perfil === 'admin' || u.perfil === 'expedicao';
  const podeAnexos = os => os.status !== 'recebido_loja' && (u.perfil === 'admin' || u.loja_id === os.loja_id);

  const registrarDiv = async () => {
    if (!novaDiv?.trim()) return;
    try {
      await api(`/ordens/${id}/divergencia`, { method: 'POST', body: { descricao: novaDiv } });
      setNovaDiv(null); carregar();
    } catch (e) { setErro(e.message); }
  };
  const resolverDiv = async did => {
    try { await api(`/ordens/${id}/divergencia/${did}/resolver`, { method: 'PATCH' }); carregar(); }
    catch (e) { setErro(e.message); }
  };
  const addAnexos = async files => {
    if (!files.length) return;
    try {
      const form = new FormData();
      [...files].slice(0, 6).forEach(a => form.append('anexos', a));
      await api(`/ordens/${id}/anexos`, { method: 'POST', form }); carregar();
    } catch (e) { setErro(e.message); }
  };
  const delAnexo = async idx => {
    if (!confirm('Excluir esta foto?')) return;
    try { await api(`/ordens/${id}/anexos/${idx}`, { method: 'DELETE' }); carregar(); }
    catch (e) { setErro(e.message); }
  };

  const carregar = () => api(`/ordens/${id}`).then(setOs).catch(e => setErro(e.message));
  useEffect(() => { carregar(); }, [id]);

  if (erro) return <div className="erro">{erro}</div>;
  if (!os) return <div className="card">Carregando…</div>;

  const idx = FLUXO.indexOf(os.status);
  const proximo = FLUXO[idx + 1];
  const podeAvancar = !os.cancelada && proximo && (
    proximo === 'recebido_loja'
      ? (u.perfil === 'admin' || u.loja_id === os.loja_id)   // etapa final: só a loja de origem (admin como exceção)
      : (u.perfil === 'admin' || u.perms?.alterar_status)
  );

  const avancar = async () => {
    try { await api(`/ordens/${id}/status`, { method: 'PATCH' }); carregar(); }
    catch (e) { setErro(e.message); }
  };

  return (
    <div className="grid">
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <div>
          <Link to="/ordens" className="btn-link">← Voltar</Link>
          <h2>OS {os.numero_os} · {os.cliente}</h2>
          <div style={{ fontSize: 13, color: 'var(--cinza)' }}>
            {os.loja_nome} · digitada por {os.digitado_por} em {fmtData(os.criado_em)}
          </div>
        </div>
        <div className="row">
          <span className="badge" style={{ background: ST_COR[os.status] + '22', color: ST_COR[os.status], fontSize: 13 }}>
            {ST_LABEL[os.status]}
          </span>
          {podeDivergencia && !os.cancelada && os.status !== 'recebido_loja' && (
            <button className="btn-sec" onClick={cancelarOS}>Cancelar OS</button>
          )}
          {podeDivergencia && !!os.cancelada && (
            <button className="btn" onClick={reativarOS}>Reativar OS</button>
          )}
          {u.perfil === 'admin' && !editando && (
            <button className="btn-sec" onClick={iniciarEdicao}>Editar OS</button>
          )}
          {u.perfil === 'admin' && (
            <button className="btn-sec" style={{ color: 'var(--vermelho)', borderColor: 'var(--vermelho)' }}
              onClick={excluirOS}>Excluir OS</button>
          )}
          {!os.cancelada && os.status === 'montagem' && podeDivergencia && (
            <button className="btn-sec" style={{ color: '#b91c1c', borderColor: '#b91c1c' }}
              onClick={() => setPerdaTxt('')}><Icone nome="refazer" size={13} /> Perda na montagem</button>
          )}
          {podeAvancar && <button className="btn" onClick={avancar}>→ {ST_LABEL[proximo]}</button>}
        </div>
      </div>

      {editando && (
        <div className="card" style={{ background: 'var(--verde-claro)' }}>
          <h3 className="card-title">Editando OS — as alterações ficam registradas no histórico</h3>
          <div className="row">
            <div style={{ flex: 1 }}><label className="label">Nº OS</label>
              <input className="input" value={editando.numero_os} onChange={e => ed('numero_os', e.target.value)} /></div>
            <div style={{ flex: 2 }}><label className="label">Cliente</label>
              <input className="input" value={editando.cliente} onChange={e => ed('cliente', e.target.value)} /></div>
            <div style={{ flex: 1 }}><label className="label">Vendedor(a)</label>
              <input className="input" value={editando.vendedor} onChange={e => ed('vendedor', e.target.value)} /></div>
          </div>
          <div className="row" style={{ marginTop: 8 }}>
            <div style={{ flex: 1 }}><label className="label">Armação</label>
              <input className="input" value={editando.armacao} onChange={e => ed('armacao', e.target.value)} /></div>
            <div style={{ flex: 1 }}><label className="label">Lente</label>
              <input className="input" value={editando.lente} onChange={e => ed('lente', e.target.value)} /></div>
          </div>
          <div className="row" style={{ marginTop: 8 }}>
            <div style={{ flex: 1 }}><label className="label">Tratamento 1</label>
              <input className="input" value={editando.tratamento1} onChange={e => ed('tratamento1', e.target.value)} /></div>
            <div style={{ flex: 1 }}><label className="label">Tratamento 2</label>
              <input className="input" value={editando.tratamento2} onChange={e => ed('tratamento2', e.target.value)} /></div>
            <div style={{ flex: 1 }}><label className="label">Tipo de armação</label>
              <select className="select" value={editando.tipo_armacao || ''} onChange={e => ed('tipo_armacao', e.target.value)}>
                <option value="">—</option>
                <option value="acetato">Acetato</option><option value="metal">Metal</option>
                <option value="metal_nylon">Metal / Nylon</option><option value="parafusado">Parafusado</option>
              </select></div>
          </div>
          <div className="row" style={{ marginTop: 8 }}>
            {[['largura','Largura'],['altura_arm','Altura'],['ponte','Ponte'],['diagonal','Diagonal']].map(([k,l]) => (
              <div key={k} style={{ flex: 1 }}><label className="label">{l}</label>
                <input className="input" value={editando[k]} onChange={e => ed(k, e.target.value)} /></div>
            ))}
          </div>
          {['od','oe'].map(olho => (
            <div className="row" key={olho} style={{ marginTop: 8 }}>
              <strong style={{ width: 28, color: 'var(--verde)' }}>{olho.toUpperCase()}</strong>
              <div style={{ flex: 1 }}><label className="label">Esférico</label>
                <select className="select" value={editando[`${olho}_esferico`] ?? ''} onChange={e => ed(`${olho}_esferico`, e.target.value)}>
                  {ESFERICOS.map(o => <option key={o} value={o.replace('+','')}>{o === '' ? '—' : o}</option>)}
                </select></div>
              <div style={{ flex: 1 }}><label className="label">Cilíndrico</label>
                <select className="select" value={editando[`${olho}_cilindrico`] ?? ''} onChange={e => ed(`${olho}_cilindrico`, e.target.value)}>
                  {CILINDRICOS.map(o => <option key={o} value={o}>{o === '' ? '—' : o}</option>)}
                </select></div>
              <div style={{ flex: 1 }}><label className="label">Eixo</label>
                <input className="input" value={editando[`${olho}_eixo`]} onChange={e => ed(`${olho}_eixo`, e.target.value)} /></div>
              <div style={{ flex: 1 }}><label className="label">Altura</label>
                <input className="input" value={editando[`${olho}_altura`]} onChange={e => ed(`${olho}_altura`, e.target.value)} /></div>
              <div style={{ flex: 1 }}><label className="label">DNP</label>
                <input className="input" value={editando[`${olho}_dnp`]} onChange={e => ed(`${olho}_dnp`, e.target.value)} /></div>
              <div style={{ flex: 1 }}><label className="label">Adição</label>
                <select className="select" value={editando[`${olho}_adicao`] ?? ''} onChange={e => ed(`${olho}_adicao`, e.target.value)}>
                  {ADICOES.map(o => <option key={o} value={o.replace('+','')}>{o === '' ? '—' : o}</option>)}
                </select></div>
            </div>
          ))}
          <div style={{ marginTop: 8 }}>
            <label className="label">Observações</label>
            <textarea className="textarea" rows={2} value={editando.observacoes} onChange={e => ed('observacoes', e.target.value)} />
          </div>
          <div className="row" style={{ marginTop: 10 }}>
            <button className="btn" onClick={salvarEdicao}>Salvar alterações</button>
            <button className="btn-sec" onClick={() => setEditando(null)}>Cancelar</button>
          </div>
        </div>
      )}
      {!!os.cancelada && (() => {
        const c = [...(os.historico || [])].reverse().find(h => h.status === 'cancelada');
        return (
          <div className="erro" style={{ background: '#eef1f2', color: 'var(--cinza)', borderLeft: '4px solid var(--cinza)' }}>
            Esta OS está CANCELADA{c ? ` desde ${fmtData(c.data_hora)}` : ''}{c?.observacao ? ` — motivo: "${c.observacao}"` : ''}. Ela não avança na produção; use "Reativar OS" para retomá-la.
          </div>
        );
      })()}
      {perdaTxt !== null && (
        <div className="card" style={{ background: '#fdecec', borderColor: '#b91c1c' }}>
          <label className="label">O que aconteceu na montagem? (a loja verá esta observação)</label>
          <textarea className="textarea" rows={2} autoFocus value={perdaTxt}
            onChange={e => setPerdaTxt(e.target.value)}
            placeholder="Ex.: Lente do olho direito arranhou na montagem — refazendo o pedido no laboratório" />
          <div className="row" style={{ marginTop: 8 }}>
            <button className="btn" style={{ background: '#b91c1c' }} onClick={registrarPerda}>
              Registrar perda e voltar p/ Pedido Feito
            </button>
            <button className="btn-sec" onClick={() => setPerdaTxt(null)}>Cancelar</button>
          </div>
        </div>
      )}
      {(() => {
        const perdas = (os.historico || []).filter(h => h.status === 'perda_montagem');
        if (!perdas.length || os.status === 'recebido_loja') return null;
        const ult = perdas[perdas.length - 1];
        return (
          <div className="erro">
            Esta OS teve perda na montagem em {fmtData(ult.data_hora)}: "{ult.observacao}" — um novo pedido foi iniciado.
          </div>
        );
      })()}
      <div className="steps">
        {FLUXO.map((s, i) => (
          <span key={s} title={ST_LABEL[s]} style={{ background: i <= idx ? ST_COR[s] : undefined }} />
        ))}
      </div>

      <div className="grid duas-colunas" style={{ gridTemplateColumns: '1fr 1fr' }}>
        <div className="card">
          <h3 className="card-title">Produtos / Serviços</h3>
          <table className="tbl"><tbody>
            <tr><td style={{ color: 'var(--cinza)' }}>Armação</td><td>{v(os.armacao)}</td></tr>
            <tr><td style={{ color: 'var(--cinza)' }}>Lente</td><td>{v(os.lente)}</td></tr>
            <tr><td style={{ color: 'var(--cinza)' }}>Tratamento 1</td><td>{v(os.tratamento1)}</td></tr>
            <tr><td style={{ color: 'var(--cinza)' }}>Tratamento 2</td><td>{v(os.tratamento2)}</td></tr>
            <tr><td style={{ color: 'var(--cinza)' }}>Tipo de armação</td><td>{v(TIPO[os.tipo_armacao])}</td></tr>
            {podeDivergencia && (
              <tr><td style={{ color: 'var(--cinza)' }}>Fornecedor</td>
                <td>
                  <select className="select" style={{ fontSize: 13, padding: '5px 6px' }}
                    value={os.fornecedor_id || ''}
                    onChange={e => salvarExp({ fornecedor_id: e.target.value })}>
                    <option value="">—</option>
                    {fornecedores.filter(fo => fo.ativo || fo.id === os.fornecedor_id).map(fo =>
                      <option key={fo.id} value={fo.id}>{fo.nome}</option>)}
                  </select>
                </td></tr>
            )}
            {podeDivergencia && (
              <tr><td style={{ color: 'var(--cinza)' }}>Nº do pedido</td>
                <td>
                  <input className="input" style={{ width: 140, fontSize: 13, padding: '5px 7px' }}
                    defaultValue={os.numero_pedido || ''} placeholder="nº no fornecedor"
                    onBlur={e => e.target.value !== (os.numero_pedido || '') && salvarExp({ numero_pedido: e.target.value })}
                    onKeyDown={e => e.key === 'Enter' && e.target.blur()} />
                </td></tr>
            )}
            {podeDivergencia && (
              <tr><td style={{ color: 'var(--cinza)' }}>Caixa (expedição)</td>
                <td>
                  <input className="input" style={{ width: 90, fontSize: 13, padding: '5px 7px' }}
                    defaultValue={os.caixa || ''} placeholder="1 a 50"
                    onBlur={e => e.target.value !== (os.caixa || '') && salvarExp({ caixa: e.target.value })}
                    onKeyDown={e => e.key === 'Enter' && e.target.blur()} />
                </td></tr>
            )}
            <tr><td style={{ color: 'var(--cinza)' }}>Vendedor(a)</td><td>{v(os.vendedor)}</td></tr>
          </tbody></table>
        </div>

        <div className="card">
          <h3 className="card-title">Medidas · Forma</h3>
          <table className="tbl"><tbody>
            <tr><td style={{ color: 'var(--cinza)' }}>1 · Largura</td><td>{v(os.largura)}</td></tr>
            <tr><td style={{ color: 'var(--cinza)' }}>2 · Altura</td><td>{v(os.altura_arm)}</td></tr>
            <tr><td style={{ color: 'var(--cinza)' }}>3 · Ponte</td><td>{v(os.ponte)}</td></tr>
            <tr><td style={{ color: 'var(--cinza)' }}>4 · Diagonal</td><td>{v(os.diagonal)}</td></tr>
            <tr>
              <td style={{ color: 'var(--cinza)' }}>Forma</td>
              <td>
                {os.forma_numero ? `${os.forma_numero} · ${os.forma_descricao || ''}` : '—'}
                {os.forma_imagem && <img src={os.forma_imagem} alt="" style={{ maxHeight: 36, display: 'block', marginTop: 4 }} />}
              </td>
            </tr>
            {os.foto_armacao_url && (
              <tr><td style={{ color: 'var(--cinza)' }}>Foto</td>
                <td><a href={os.foto_armacao_url} target="_blank" rel="noreferrer" className="btn-link">Ver foto da armação</a></td></tr>
            )}
          </tbody></table>
        </div>
      </div>

      <div className="card">
        <h3 className="card-title">Receita · {os.olhos === 'ambos' ? 'Ambos os olhos' : os.olhos === 'direito' ? 'Olho direito' : 'Olho esquerdo'}</h3>
        <table className="tbl">
          <thead><tr><th></th><th>Esférico</th><th>Cilíndrico</th><th>Eixo</th><th>Altura</th><th>DNP</th><th>Adição</th></tr></thead>
          <tbody>
            {os.olhos !== 'esquerdo' && (
              <tr><td style={{ fontWeight: 800, color: 'var(--verde)' }}>OD</td>
                <td>{v(os.od_esferico)}</td><td>{v(os.od_cilindrico)}</td><td>{v(os.od_eixo)}</td>
                <td>{v(os.od_altura)}</td><td>{v(os.od_dnp)}</td><td>{v(os.od_adicao)}</td></tr>
            )}
            {os.olhos !== 'direito' && (
              <tr><td style={{ fontWeight: 800, color: 'var(--verde)' }}>OE</td>
                <td>{v(os.oe_esferico)}</td><td>{v(os.oe_cilindrico)}</td><td>{v(os.oe_eixo)}</td>
                <td>{v(os.oe_altura)}</td><td>{v(os.oe_dnp)}</td><td>{v(os.oe_adicao)}</td></tr>
            )}
          </tbody>
        </table>
        {os.observacoes && <p style={{ fontSize: 13, color: 'var(--cinza)', marginBottom: 0 }}><strong>Obs.:</strong> {os.observacoes}</p>}
      </div>

      {(() => {
        let anexos = [];
        try { anexos = os.anexos_urls ? JSON.parse(os.anexos_urls) : []; } catch {}
        const editavel = podeAnexos(os);
        return (anexos.length > 0 || editavel) && (
          <div className="card">
            <h3 className="card-title">Fotos da receita / OS física</h3>
            <div className="row">
              {anexos.map((a, i) => (
                <div key={i} style={{ position: 'relative' }}>
                  <a href={a} target="_blank" rel="noreferrer">
                    <img src={a} alt={`Anexo ${i + 1}`}
                      style={{ height: 90, borderRadius: 6, border: '1px solid var(--linha)' }} />
                  </a>
                  {u.perfil === 'admin' && (
                    <button onClick={() => delAnexo(i)} title="Excluir foto"
                      style={{ position: 'absolute', top: -6, right: -6, background: 'var(--vermelho)',
                        color: '#fff', border: 'none', borderRadius: '50%', width: 20, height: 20,
                        fontSize: 11, fontWeight: 800, cursor: 'pointer', lineHeight: 1 }}>✕</button>
                  )}
                </div>
              ))}
            </div>
            {editavel && (
              <label className="btn-sec" style={{ display: 'inline-block', marginTop: 10, cursor: 'pointer' }}>
                + Adicionar fotos
                <input type="file" accept="image/*" multiple hidden
                  onChange={e => { addAnexos(e.target.files); e.target.value = ''; }} />
              </label>
            )}
          </div>
        );
      })()}

      <div className="card" style={(os.divergencias || []).some(d => !d.resolvida) ? { borderColor: 'var(--vermelho)' } : {}}>
        <div className="row" style={{ justifyContent: 'space-between', marginBottom: 8 }}>
          <h3 className="card-title" style={{ marginBottom: 0 }}>Divergências</h3>
          {podeDivergencia && novaDiv === null && (
            <button className="btn-sec" onClick={() => setNovaDiv('')}>+ Registrar divergência</button>
          )}
        </div>
        {novaDiv !== null && (
          <div style={{ background: '#fdecec', borderRadius: 8, padding: 10, marginBottom: 10 }}>
            <label className="label">Descreva a divergência entre o digitado e a OS física</label>
            <textarea className="textarea" rows={2} autoFocus value={novaDiv}
              onChange={e => setNovaDiv(e.target.value)}
              placeholder="Ex.: Esférico OD digitado -2.00, mas na ficha física está -2.25" />
            <div className="row" style={{ marginTop: 8 }}>
              <button className="btn" onClick={registrarDiv}>Salvar divergência</button>
              <button className="btn-sec" onClick={() => setNovaDiv(null)}>Cancelar</button>
            </div>
          </div>
        )}
        {(os.divergencias || []).length === 0 && novaDiv === null && (
          <p style={{ fontSize: 13, color: 'var(--cinza)', margin: 0 }}>Nenhuma divergência registrada nesta OS.</p>
        )}
        {(os.divergencias || []).map(d => (
          <div key={d.id} style={{ borderTop: '1px solid var(--linha)', padding: '8px 0' }}>
            <div className="row" style={{ justifyContent: 'space-between' }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13.5 }}>{d.descricao}</div>
                <div style={{ fontSize: 11.5, color: 'var(--cinza)' }}>
                  Registrada por {d.registrado_por} em {fmtData(d.criado_em)}
                  {d.resolvida ? ` · resolvida por ${d.resolvido_por} em ${fmtData(d.resolvida_em)}` : ''}
                </div>
              </div>
              {d.resolvida ? (
                <span className="badge" style={{ background: '#e2f3e8', color: 'var(--ok)' }}>Resolvida</span>
              ) : (
                <div className="row">
                  <span className="badge" style={{ background: '#fdecec', color: 'var(--vermelho)' }}>Pendente</span>
                  {podeDivergencia && (
                    <button className="btn-sec" onClick={() => resolverDiv(d.id)}>Marcar resolvida</button>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="card">
        <h3 className="card-title">Histórico</h3>
        {os.historico.map((h, i) => (
          <div key={i} style={{ padding: '4px 0', fontSize: 13.5,
            background: h.status === 'perda_montagem' ? '#fdecec' : undefined,
            borderRadius: 6, paddingLeft: h.status === 'perda_montagem' ? 8 : 0 }}>
            <div className="row">
              <span style={{ color: 'var(--cinza)', minWidth: 100 }}>{fmtData(h.data_hora)}</span>
              <span style={{ fontWeight: 700, color: h.status === 'perda_montagem' ? '#b91c1c' : undefined }}>
                {ST_LABEL[h.status]}
              </span>
              <span style={{ color: 'var(--cinza)' }}>· {h.usuario}</span>
            </div>
            {h.observacao && (
              <div style={{ fontSize: 12.5, color: h.status === 'perda_montagem' ? '#b91c1c' : 'var(--cinza)',
                marginLeft: 100, paddingLeft: 10 }}>
                "{h.observacao}"
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
